import * as React from 'react'
import CustomFlagIconFactory from 'react-flag-icon-css'
import {codes} from '../assets/customFlags'

const options = {useCssModules: false,customCodes: codes}

export default CustomFlagIconFactory(React, options)
